
/* eslint-disable no-unused-vars */
import { defineComponent, ref, computed, watch, nextTick } from "vue";
import { fabric } from "fabric";

import { store } from "@/store";

import LabelShapesButton from "./LabelShapesButton.vue";
import LabelSizesButton from "./LabelSizesButton.vue";
import CustomLabelSizesButton from "./CustomLabelSizesButton.vue";
import LabelMaterialsButton from "./LabelMaterialsButton.vue";

import { doPaste, clonedObject, setObjectPosition, copyActiveObject, } from "@/canvas-api/ObjectUtility";
import { undo, redo } from "@/canvas-api/ActionStack";

import { LabelSizes, LabelShapes, CurrentLabel, ClientDimensions, isFabricObject } from "@/types";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "TopToolBar",
  components: {
    LabelShapesButton,
    LabelSizesButton,
    CustomLabelSizesButton,
    LabelMaterialsButton,
  },
  setup() {
    const backUrl = window.document.referrer;

    const isMobile = computed<string>(() => store.getters.isMobile);
    const clientDimensions = computed<ClientDimensions>(() => store.getters.clientDimensions);

    const currentLabelType = computed<string>(() => store.getters.currentLabelType);
    const currentLabel = computed<CurrentLabel>(() => store.getters.currentLabel);
    const labelSizes = computed<LabelSizes[]>(() => store.getters.labelSizes);
    const customLabelSizes = computed<LabelSizes[]>(() => store.getters.customLabelSizes);
    const labelShapes = computed<LabelShapes[]>(() => store.getters.labelShapes);

    const currentActiveObject = computed<fabric.Object>(() => store.getters.currentActiveObject);
    const isCopied = computed<boolean>(() => isFabricObject(clonedObject.value));

    const handleCopy = () => {
      if (currentActiveObject.value) copyActiveObject();
    };

    const handlePaste = () => {
      if (currentActiveObject.value) doPaste.value = true;
    };

    const showDropDown = ref(false);
    const dropBody = ref<HTMLDivElement>();
    const dropContainer = ref<HTMLDivElement>();

    const handleDropDown = async () => {
      showDropDown.value = !showDropDown.value;

      await nextTick();
      if (dropBody.value && dropContainer.value) {
        let dropContainerBCR = dropContainer.value.getBoundingClientRect();
        let dropBodyBCR = dropBody.value.getBoundingClientRect();

        // prettier-ignore
        dropBody.value.style.left = `${dropContainerBCR.left - dropBodyBCR.width / 2 + dropContainerBCR.width / 2}px`;
        dropBody.value.style.top = "60px"; //#top-tool-bar-component height
      }
    };

    watch(currentActiveObject, (activeObj: fabric.Object) => {
      if (!activeObj) {
        showDropDown.value = false;
      }
    });

    const alignObject = (position: string) => {
      setObjectPosition(position);
    };

    const handleUndo = () => {
      undo();
    };

    const handleRedo = () => {
      redo();
    };

    const backButton = () => {
      store.dispatch(ActionTypes.SET_MODAL, 'confirmBack');
    }

    return {
      clonedObject,
      backUrl,
      isMobile,
      clientDimensions,
      currentLabelType,
      currentLabel,
      labelSizes,
      customLabelSizes,
      labelShapes,
      currentActiveObject,
      isCopied,
      handleCopy,
      handlePaste,
      showDropDown,
      dropBody,
      dropContainer,
      handleDropDown,
      alignObject,
      handleUndo,
      handleRedo,
      backButton,
    };
  },
});
